import React, { useLayoutEffect, useRef } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'

import { getConstanceSetting } from '@disco/state-management/selectors/user'
import { isTrialExpired } from '@disco/utils/trial'

import DocumentHeadTags from 'components/document-head-tags'
import PricingModal from 'components/modals/pricing'

import TrialExpiredModal from './trial-expired-modal'

const mapStateToProps = state => ({
  user: state.user,
  isGrowthTrialSignup: Boolean(
    getConstanceSetting(state, 'CB-59-GROWTH-AT-EXPIRED-TRIAL'),
  ),
})

const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const ConnectedPricingPage = connector(PricingPage)

function PricingPage({ user, isGrowthTrialSignup }: PropsFromRedux) {
  const navigate = useNavigate()

  const _onClose = () => navigate('/')

  const trialExpired = isTrialExpired(user)
  const closeEnabled =
    !user.business.private_metadata.expired_subscription && !trialExpired

  const wasTrialExpired = useRef(trialExpired)
  // payment finishes in Chargebee, so leave from here
  useLayoutEffect(() => {
    if (isGrowthTrialSignup && wasTrialExpired.current && !trialExpired)
      navigate('/')
    wasTrialExpired.current = trialExpired
  }, [isGrowthTrialSignup, trialExpired, navigate])

  // the legacy grid loads data on mount, so don't mount it on the way out
  const leavingAfterPayment =
    isGrowthTrialSignup && wasTrialExpired.current && !trialExpired

  return (
    <div>
      <DocumentHeadTags title="Pricing | DISCO" />
      {isGrowthTrialSignup && trialExpired ? (
        <TrialExpiredModal />
      ) : leavingAfterPayment ? null : (
        <PricingModal
          onClose={closeEnabled ? _onClose : undefined}
          showBillingSummary
        />
      )}
      <Outlet />
    </div>
  )
}

export default ConnectedPricingPage
